<template>
  <div slot="list" class="goods-list">
    <div v-for="(item, index) in list" :key="index" class="goods-item" @click="toLogs(item)">
      <div class="d-flex flex-row w-100">
        <div class="name flex-1">{{item.name}}</div>
        <div class="money">
          <span class="balance">{{item.balance}}</span>
          <span class="pie">/</span>
          <span class="denomination">{{item.denomination}}</span>
        </div>
      </div>
      <div class="w-100 code">{{item.code}}</div>
      <div class="w-100 timeStr">有效期 {{item.createTimeStr+' '+item.expirytimeStr}}</div>
      <div class="mask" v-if="!item.valid"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
    };
  },

  mounted () {
    this.getList()
  },
  methods: {
    getList (page, size, param) {
      this.$http.request(this.$http.pathMap.cardList, 'get').then(res => {
        let data = res.data
        data.forEach(item => {
          item.createTimeStr = this.$uitl.formatTime('YYYY-mm-dd', new Date(item.createTime))
          item.expirytimeStr = this.$uitl.formatTime('YYYY-mm-dd', new Date(item.expiryDate))
        })
        this.list = data
      })
    },
    toLogs (item) {
      this.$router.push({
        path: '/pages/card/cardLog',
        query: {
          shoppingCardId: item.id
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/* 分类 */
/* 商品列表 */
.goods-list {
  padding: 0 10px;
  .goods-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    padding: 10px;
    height: 200px;
    width: 100%;
    margin-top: 10px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
    background: url("../../../static/card.jpg") no-repeat;
    background-size: 100% 100%;
    border-radius: 10px;
    .mask {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 9;
      background-color: rgba(255, 255, 255, 0.6);
    }
    .name {
      color: white;
      font-size: 18px;
    }
    .money {
      // display: flex;
      // flex-direction: row;
      // justify-content: center;
      // align-items: flex-end;
      vertical-align: baseline;
      .balance {
        line-height: 28px;
        font-size: 28px;
        font-weight: 400;
        color: white;
      }
      .pie {
        font-size: 14px;
        font-weight: 300;
        color: white;
      }
      .denomination {
        font-size: 14px;
        font-weight: 300;
        color: white;
      }
    }

    .timeStr {
      color: white;
      font-size: 12px;
      text-align: end;
    }
    .code {
      margin-top: 50px;
      text-align: start;
      text-transform: uppercase;
      color: white;
    }
  }
}
</style>
